import useRain from "./hooks/makeRain";

export default function Rain() {
    useRain()

    return null
}